module.exports = __webpack_public_path__ + "479b67f3cada2a244ef6dd571a01f546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/score-0.svg
// module id = 160
// module chunks = 0